import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {ApolloGqlClient} from "#data-access/gql/apollo-types.ts";

import type {
    getNonProfileKhanmigoCheckoutEligibilityData as QueryData,
    getNonProfileKhanmigoCheckoutEligibilityData_user as User,
} from "./__graphql-types__/getNonProfileKhanmigoCheckoutEligibilityData.ts";

export type EligibilityData = {
    childCount: number;
    age: number | null | undefined;
    hasKhanmigoViaStripe: boolean;
};

export const GET_KHANMIGO_ELIGIBILITY_DATA: GqlOperation<QueryData> = gqlOp(gql`
    query getNonProfileKhanmigoCheckoutEligibilityData {
        user {
            id
            children {
                id
            }
            age
            hasKhanmigoViaStripe
        }
    }
`);

function mapUserDataToEligibilityData(userData: User): EligibilityData {
    return {
        childCount: (userData.children && userData.children.length) || 0,
        age: userData.age,
        hasKhanmigoViaStripe: userData.hasKhanmigoViaStripe,
    };
}

export const fetchKhanmigoEligibilityData = async (
    gqlClient: ApolloGqlClient,
): Promise<EligibilityData | null> => {
    const result = await gqlClient.query(GET_KHANMIGO_ELIGIBILITY_DATA, {
        fetchPolicy: "network-only",
    });

    return (
        (result.data &&
            result.data.user &&
            mapUserDataToEligibilityData(result.data.user)) ||
        null
    );
};
